import { Controller } from "@hotwired/stimulus"

import TomSelect from "tom-select";

// Connects to data-controller="tom-select-remote"
export default class extends Controller {
  connect() {
    const elements = this.element.tagName == "SELECT" ? [this.element] : this.element.querySelectorAll('.tom-select')
    let plugins = {}
    let search_param = "q%5Bname_cont%5D"
    elements.forEach((el) => {
      if (!el.tomselect) {
        if (el.multiple) {
          plugins = { remove_button: { title: 'Remover' } }
        } else {
          plugins = { clear_button: { title: 'Limpar' } }
        }
        let settings = {
          itemClass: `item ${el.dataset.itemClass}`,
          valueField: 'id',
          labelField: 'name',
          searchField: 'name',
          sortField: {
            field: "name",
            direction: "asc"
          },
          plugins: plugins,
          onItemAdd: function () {
            this.setTextboxValue('');
            this.refreshOptions();
          },
          load: function (query, callback) {
            fetch(`${el.dataset.endpoint}?${el.dataset.search_param || search_param}=${query}`)
              .then(response => response.json())
              .then(data => {
                callback(data)
              }).catch(err => console.log(err))
          }
        }
        new TomSelect(el, settings)
      }
    })
  }
}
